var isWindowSliding = false;

$(function() {

  setCurrency();

  $(document).mousemove(function(e) {
    if (!isWindowSliding) {
      if (e.pageX - $(document).scrollLeft() < 60) {
        isWindowSliding = true;
        $("html, body").animate({scrollLeft: 0}, 1000, function() {
          isWindowSliding = false;
        });
      }
      else if (e.pageX - $(document).scrollLeft() > $(window).width() - 60) {
        isWindowSliding = true;
        $("html, body").animate({scrollLeft: 1200 - $(window).width()}, 1000, function() {
          isWindowSliding = false;
        });
      }
    }
  });


  /*$(".menu_dynamic_width > li").each(function() {
    $(this).width($(this).width())
           .find("a").addClass("menu_li_a");
  });*/

  $(".menu .has_submenu").hover(
    function() {
      $(this).find(".submenu").show();
    },
    function() {
      $(this).find(".submenu").hide();
    }
  );

  $("#currencies_submenu li").on("click", function() {
    $("#currencies").val($(this).find(".currency_flag").attr("alt")).trigger("change");
    setCurrency();
    $("#currencies_submenu").hide();
  });

  $("#header_menu_cart_menu").hover(
    function() {
      $("#header_menu_cart").show();
    },
    function() {
      $("#header_menu_cart").hide();
    }
  );

  $("#header_menu_cart_close").on("click", function() {
    $("#header_menu_cart").hide();
  });

  $("#mailing_list_form").on("submit", function() {
    $(this).find("input[type='email']").removeClass("error_input");
    var email = $(this).find("input[type='email']").val();

    if (email == "" || !isEmailValid(email)) {
      $(this).find("input[type='email']").addClass("error_input");
    }
    else {
      /*$.post("ajax/subscribe.ajax.php", {
        "email": email
      }, function(msg) {
        if (msg == "1") {
          $("#mailing_list_form").fadeOut(500, function() {
            $("#subscribe_success_message").fadeIn(500);
          });
        }
      });*/
    }

    return false;
  });

});

function isEmailValid(email) {
  return (email.match(/^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,3})$/i) != null) ? true : false;
}

function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function setCurrency() {
  var selectedCurrency = $("#currencies option:selected").val();

  $("#currencies_submenu li").show();
  var li = $("#currency_" + selectedCurrency);
  li.hide();

  $("#currency_flag").attr("src", li.find(".currency_flag").attr("src"));
  $("#currency_text").html(selectedCurrency);
}

function showDiscountPopup() {
  $("#mask, #discount_popup").fadeIn();
}
